<template>
  <div class="container-details">
    <div class="alerts" v-if="getSingleShipments.pod_timeofarrival_warning">
      <div v-for="(incident, index) in parsedIncidents" :key="index" class="alert">
        {{ incident.message }}
      </div>
    </div>
    <b-row class="mb-2">
      <b-col md="3" class="mt-1 mb-1" @click="getShipmentLog(getSingleShipments)">
        Shipment ID :
        <strong style="color: blue"
          ><u>{{ getSingleShipments.id }}</u></strong
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Booking No : <strong>{{ getSingleShipments.booking_number }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        >Container : <strong>{{ getSingleShipments.container_number }}</strong></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span>Container Type : {{ getSingleShipments.container_type_str }}</span></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span>Container ISO : {{ getSingleShipments.container_type_iso }}</span></b-col
      >
      <b-col md="3" class="mt-1 mb-1">
        Subscription ID :
        <strong>{{ getSingleShipments.shipmentsubscription_id }}</strong></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Carrier Name : <strong>{{ getSingleShipments.carrier_name }}</strong></span
        >
      </b-col>
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Carrier SCAC : <strong>{{ getSingleShipments.carrier_scac }}</strong></span
        >
      </b-col>
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Carrier Release State :
          <strong>{{ getSingleShipments.carrier_release_state }}</strong></span
        >
      </b-col>
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Carrier Release Date :
          <strong>{{ getSingleShipments.carrier_release_date?(getSingleShipments.carrier_release_date | moment):"" }}</strong></span
        >
      </b-col>
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Status Verbose : <strong>{{ getSingleShipments.status_verbose }}</strong></span
        >
      </b-col>
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Subscription Status :
          <strong>{{
            getSingleShipments.shipmentsubscription_status_verbose
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Subscription Lifecycle Status :
          <strong>{{ getSingleShipments.lifecycle_status_verbose }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Bl No : <strong>{{ getSingleShipments.bl_number }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >ID Date : <strong>{{ getSingleShipments.id_date?(getSingleShipments.id_date | moment):"" }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Empty Pickup Planned Initial :<strong>{{
            getSingleShipments.empty_pickup_planned_initial?(getSingleShipments.empty_pickup_planned_initial | moment):""
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Empty Pickup Planned Last :<strong>{{
            getSingleShipments.empty_pickup_planned_last?(getSingleShipments.empty_pickup_planned_last | moment):""
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Empty Pickup Actual :<strong>{{
            getSingleShipments.empty_pickup_actual?(getSingleShipments.empty_pickup_actual | moment):""
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Origin Pickup Planned Initial :<strong>{{
            getSingleShipments.origin_pickup_planned_initial?(getSingleShipments.origin_pickup_planned_initial | moment):""
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Origin Pickup Planned Last :<strong>{{
            getSingleShipments.origin_pickup_planned_last?(getSingleShipments.origin_pickup_planned_last | moment):""
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Origin Pickup Actual :<strong>{{
            getSingleShipments.origin_pickup_actual?(getSingleShipments.origin_pickup_actual | moment):""
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >POL Arrival Planned Initial :<strong>{{
            getSingleShipments.pol_arrival_planned_initial?(getSingleShipments.pol_arrival_planned_initial | moment):""
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >POL Arrival Planned Last :<strong>{{
            getSingleShipments.pol_arrival_planned_last?(getSingleShipments.pol_arrival_planned_last | moment):""
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >POL Arrival Actual :<strong>{{
            getSingleShipments.pol_arrival_actual?(getSingleShipments.pol_arrival_actual | moment):""
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >POL Loaded Planned Initial :<strong>{{
            getSingleShipments.pol_loaded_planned_initial?(getSingleShipments.pol_loaded_planned_initial | moment):""
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >POL Loaded Planned Last :<strong>{{
            getSingleShipments.pol_loaded_planned_last?(getSingleShipments.pol_loaded_planned_last | moment):""
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >POL Loaded Actual :<strong>{{
            getSingleShipments.pol_loaded_actual?(getSingleShipments.pol_loaded_actual | moment):""
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >POL VSL Departure Planned Initial :<strong>{{
            getSingleShipments.pol_vsldeparture_planned_initial?(getSingleShipments.pol_vsldeparture_planned_initial | moment):""
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >POL VSL Departure Planned Last :<strong>{{
            getSingleShipments.pol_vsldeparture_planned_last?(getSingleShipments.pol_vsldeparture_planned_last | moment):""
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >POL VSL Departure Actual :<strong>{{
            getSingleShipments.pol_vsldeparture_actual?(getSingleShipments.pol_vsldeparture_actual | moment):""
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >POL VSL Departure Detected :<strong>{{
            getSingleShipments.pol_vsldeparture_detected?(getSingleShipments.pol_vsldeparture_detected | moment):""
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Leg 1 Voyage :<strong>{{ getSingleShipments.leg1_voyage }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Leg 2 Voyage :<strong>{{ getSingleShipments.leg2_voyage }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Leg 3 Voyage :<strong>{{ getSingleShipments.leg3_voyage }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Leg 4 Voyage :<strong>{{ getSingleShipments.leg4_voyage }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Leg 5 Voyage :<strong>{{ getSingleShipments.leg5_voyage }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Created : <strong>{{ getSingleShipments.created?(getSingleShipments.created | moment):"" }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Modified : <strong>{{ getSingleShipments.modified?(getSingleShipments.modified | moment):"" }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2" v-if="getSingleShipments.current_vessel_nextport">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Current Vessel Details</b></u></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Next Port Name :
          <strong>{{ getSingleShipments.current_vessel_nextport.name }}</strong></span
        >
      </b-col>
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Next Port Locode :
          <strong>{{ getSingleShipments.current_vessel_nextport.locode }}</strong></span
        >
      </b-col>
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Next Port ETA :
          <strong>{{
            getSingleShipments.current_vessel_nextport.eta?(getSingleShipments.current_vessel_nextport.eta | moment):""
          }}</strong></span
        >
      </b-col>
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Position Lat :
          <strong>{{ getSingleShipments.current_vessel_position.latitude }}</strong></span
        >
      </b-col>
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Position Long :
          <strong>{{
            getSingleShipments.current_vessel_position.longitude
          }}</strong></span
        >
      </b-col>
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Position Time :
          <strong>{{
            getSingleShipments.current_vessel_position.timestamp?(getSingleShipments.current_vessel_position.timestamp | moment):""
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Position Heading :
          <strong>{{ getSingleShipments.current_vessel_position.heading }}</strong></span
        >
      </b-col>
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Name : <strong>{{ getSingleShipments.current_vessel.name }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Imo : <strong>{{ getSingleShipments.current_vessel.imo }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >ID : <strong>{{ getSingleShipments.current_vessel.id }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2" v-if="getSingleShipments.tsp1_loc">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Transhipment 1 Details</b></u></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Name : <strong>{{ getSingleShipments.tsp1_loc.name }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Locode : <strong>{{ getSingleShipments.tsp1_loc.locode }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Timezone : <strong>{{ getSingleShipments.tsp1_loc.timezone }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >City : <strong>{{ getSingleShipments.tsp1_loc.city }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >State : <strong>{{ getSingleShipments.tsp1_loc.state }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Country : <strong>{{ getSingleShipments.tsp1_loc.country }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2" v-if="getSingleShipments.tsp2_loc">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Transhipment 2 Details</b></u></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Name : <strong>{{ getSingleShipments.tsp2_loc.name }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Locode : <strong>{{ getSingleShipments.tsp2_loc.locode }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Timezone : <strong>{{ getSingleShipments.tsp2_loc.timezone }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >City : <strong>{{ getSingleShipments.tsp2_loc.city }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >State : <strong>{{ getSingleShipments.tsp2_loc.state }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Country : <strong>{{ getSingleShipments.tsp2_loc.country }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2" v-if="getSingleShipments.tsp3_loc">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Transhipment 3 Details</b></u></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Name : <strong>{{ getSingleShipments.tsp3_loc.name }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Locode : <strong>{{ getSingleShipments.tsp3_loc.locode }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Timezone : <strong>{{ getSingleShipments.tsp3_loc.timezone }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >City : <strong>{{ getSingleShipments.tsp3_loc.city }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >State : <strong>{{ getSingleShipments.tsp3_loc.state }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Country : <strong>{{ getSingleShipments.tsp3_loc.country }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2" v-if="getSingleShipments.tsp4_loc">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Transhipment 4 Details</b></u></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Name : <strong>{{ getSingleShipments.tsp4_loc.name }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Locode : <strong>{{ getSingleShipments.tsp4_loc.locode }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Timezone : <strong>{{ getSingleShipments.tsp4_loc.timezone }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >City : <strong>{{ getSingleShipments.tsp4_loc.city }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >State : <strong>{{ getSingleShipments.tsp4_loc.state }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Country : <strong>{{ getSingleShipments.tsp4_loc.country }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Transhipment 1 VSL Arrival Details</b></u></b-col
      >
      <b-col
        md="3"
        class="mt-1 mb-1"
        v-if="getSingleShipments.tsp1_vslarrival_planned_initial"
        ><span
          >Planned Initial :
          <strong>{{
            getSingleShipments.tsp1_vslarrival_planned_initial?(getSingleShipments.tsp1_vslarrival_planned_initial | moment):""
          }}</strong></span
        ></b-col
      >
      <b-col
        md="3"
        class="mt-1 mb-1"
        v-if="getSingleShipments.tsp1_vslarrival_planned_last"
        ><span
          >Planned Last :
          <strong>{{
            getSingleShipments.tsp1_vslarrival_planned_last | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1" v-if="getSingleShipments.tsp1_vslarrival_actual"
        ><span
          >Actual :
          <strong>{{ getSingleShipments.tsp1_vslarrival_actual | moment }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1" v-if="getSingleShipments.tsp1_vslarrival_detected"
        ><span
          >Detected :
          <strong>{{
            getSingleShipments.tsp1_vslarrival_detected | moment
          }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Transhipment 1 Discharge Details</b></u></b-col
      >
      <b-col
        md="3"
        class="mt-1 mb-1"
        v-if="getSingleShipments.tsp1_discharge_planned_initial"
        ><span
          >Planned Initial :
          <strong>{{
            getSingleShipments.tsp1_discharge_planned_initial | moment
          }}</strong></span
        ></b-col
      >
      <b-col
        md="3"
        class="mt-1 mb-1"
        v-if="getSingleShipments.tsp1_discharge_planned_last"
        ><span
          >Planned Last :
          <strong>{{
            getSingleShipments.tsp1_discharge_planned_last | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1" v-if="getSingleShipments.tsp1_discharge_actual"
        ><span
          >Actual :
          <strong>{{ getSingleShipments.tsp1_discharge_actual | moment }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Transhipment 1 Loaded Details</b></u></b-col
      >
      <b-col
        md="3"
        class="mt-1 mb-1"
        v-if="getSingleShipments.tsp1_loaded_planned_initial"
        ><span
          >Planned Initial :
          <strong>{{
            getSingleShipments.tsp1_loaded_planned_initial | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1" v-if="getSingleShipments.tsp1_loaded_planned_last"
        ><span
          >Planned Last :
          <strong>{{
            getSingleShipments.tsp1_loaded_planned_last | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1" v-if="getSingleShipments.tsp1_loaded_actual"
        ><span
          >Actual :
          <strong>{{ getSingleShipments.tsp1_loaded_actual | moment }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Transhipment 1 VSL Departure Details</b></u></b-col
      >
      <b-col
        md="3"
        class="mt-1 mb-1"
        v-if="getSingleShipments.tsp1_vsldeparture_planned_initial"
        ><span
          >Planned Initial :
          <strong>{{
            getSingleShipments.tsp1_vsldeparture_planned_initial | moment
          }}</strong></span
        ></b-col
      >
      <b-col
        md="3"
        class="mt-1 mb-1"
        v-if="getSingleShipments.tsp1_vsldeparture_planned_last"
        ><span
          >Planned Last :
          <strong>{{
            getSingleShipments.tsp1_vsldeparture_planned_last | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1" v-if="getSingleShipments.tsp1_vsldeparture_actual"
        ><span
          >Actual :
          <strong>{{
            getSingleShipments.tsp1_vsldeparture_actual | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1" v-if="getSingleShipments.tsp1_vsldeparture_detected"
        ><span
          >Detected :
          <strong>{{
            getSingleShipments.tsp1_vsldeparture_detected | moment
          }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Transhipment 2 VSL Arrival Details</b></u></b-col
      >
      <b-col
        md="3"
        class="mt-1 mb-1"
        v-if="getSingleShipments.tsp2_vslarrival_planned_initial"
        ><span
          >Planned Initial :
          <strong>{{
            getSingleShipments.tsp2_vslarrival_planned_initial | moment
          }}</strong></span
        ></b-col
      >
      <b-col
        md="3"
        class="mt-1 mb-1"
        |
        moment
        v-if="getSingleShipments.tsp2_vslarrival_planned_last"
        ><span
          >Planned Last :
          <strong>{{
            getSingleShipments.tsp2_vslarrival_planned_last | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1" v-if="getSingleShipments.tsp2_vslarrival_actual"
        ><span
          >Actual :
          <strong>{{ getSingleShipments.tsp2_vslarrival_actual | moment }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1" v-if="getSingleShipments.tsp2_vslarrival_detected"
        ><span
          >Detected :
          <strong>{{
            getSingleShipments.tsp2_vslarrival_detected | moment
          }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Transhipment 2 Discharge Details</b></u></b-col
      >
      <b-col
        md="3"
        class="mt-1 mb-1"
        v-if="getSingleShipments.tsp2_discharge_planned_initial"
        ><span
          >Planned Initial :
          <strong>{{
            getSingleShipments.tsp2_discharge_planned_initial | moment
          }}</strong></span
        ></b-col
      >
      <b-col
        md="3"
        class="mt-1 mb-1"
        v-if="getSingleShipments.tsp2_discharge_planned_last"
        ><span
          >Planned Last :
          <strong>{{
            getSingleShipments.tsp2_discharge_planned_last | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1" v-if="getSingleShipments.tsp2_discharge_actual"
        ><span
          >Actual :
          <strong>{{ getSingleShipments.tsp2_discharge_actual | moment }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Transhipment 2 Loaded Details</b></u></b-col
      >
      <b-col
        md="3"
        class="mt-1 mb-1"
        v-if="getSingleShipments.tsp2_loaded_planned_initial"
        ><span
          >Planned Initial :
          <strong>{{
            getSingleShipments.tsp2_loaded_planned_initial | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1" v-if="getSingleShipments.tsp2_loaded_planned_last"
        ><span
          >Planned Last :
          <strong>{{
            getSingleShipments.tsp2_loaded_planned_last | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1" v-if="getSingleShipments.tsp2_loaded_actual"
        ><span
          >Actual :
          <strong>{{ getSingleShipments.tsp2_loaded_actual | moment }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Transhipment 2 VSL Departure Details</b></u></b-col
      >
      <b-col
        md="3"
        class="mt-1 mb-1"
        v-if="getSingleShipments.tsp2_vsldeparture_planned_initial"
        ><span
          >Planned Initial :
          <strong>{{
            getSingleShipments.tsp2_vsldeparture_planned_initial | moment
          }}</strong></span
        ></b-col
      >
      <b-col
        md="3"
        class="mt-1 mb-1"
        v-if="getSingleShipments.tsp2_vsldeparture_planned_last"
        ><span
          >Planned Last :
          <strong>{{
            getSingleShipments.tsp2_vsldeparture_planned_last | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1" v-if="getSingleShipments.tsp2_vsldeparture_actual"
        ><span
          >Actual :
          <strong>{{
            getSingleShipments.tsp2_vsldeparture_actual | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1" v-if="getSingleShipments.tsp2_vsldeparture_detected"
        ><span
          >Detected :
          <strong>{{
            getSingleShipments.tsp2_vsldeparture_detected | moment
          }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Transhipment 3 VSL Arrival Details</b></u></b-col
      >
      <b-col
        md="3"
        class="mt-1 mb-1"
        v-if="getSingleShipments.tsp3_vslarrival_planned_initial"
        ><span
          >Planned Initial :
          <strong>{{
            getSingleShipments.tsp3_vslarrival_planned_initial | moment
          }}</strong></span
        ></b-col
      >
      <b-col
        md="3"
        class="mt-1 mb-1"
        v-if="getSingleShipments.tsp3_vslarrival_planned_last"
        ><span
          >Planned Last :
          <strong>{{
            getSingleShipments.tsp3_vslarrival_planned_last | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1" v-if="getSingleShipments.tsp3_vslarrival_actual"
        ><span
          >Actual :
          <strong>{{ getSingleShipments.tsp3_vslarrival_actual | moment }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1" v-if="getSingleShipments.tsp3_vslarrival_detected"
        ><span
          >Detected :
          <strong>{{
            getSingleShipments.tsp3_vslarrival_detected | moment
          }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Transhipment 3 Discharge Details</b></u></b-col
      >
      <b-col
        md="3"
        class="mt-1 mb-1"
        v-if="getSingleShipments.tsp3_discharge_planned_initial"
        ><span
          >Planned Initial :
          <strong>{{
            getSingleShipments.tsp3_discharge_planned_initial | moment
          }}</strong></span
        ></b-col
      >
      <b-col
        md="3"
        class="mt-1 mb-1"
        v-if="getSingleShipments.tsp3_discharge_planned_last"
        ><span
          >Planned Last :
          <strong>{{
            getSingleShipments.tsp3_discharge_planned_last | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1" v-if="getSingleShipments.tsp3_discharge_actual"
        ><span
          >Actual :
          <strong>{{ getSingleShipments.tsp3_discharge_actual | moment }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Transhipment 3 Loaded Details</b></u></b-col
      >
      <b-col
        md="3"
        class="mt-1 mb-1"
        v-if="getSingleShipments.tsp3_loaded_planned_initial"
        ><span
          >Planned Initial :
          <strong>{{
            getSingleShipments.tsp3_loaded_planned_initial | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1" v-if="getSingleShipments.tsp3_loaded_planned_last"
        ><span
          >Planned Last :
          <strong>{{
            getSingleShipments.tsp3_loaded_planned_last | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1" v-if="getSingleShipments.tsp3_loaded_actual"
        ><span
          >Actual :
          <strong>{{ getSingleShipments.tsp3_loaded_actual | moment }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Transhipment 3 VSL Departure Details</b></u></b-col
      >
      <b-col
        md="3"
        class="mt-1 mb-1"
        v-if="getSingleShipments.tsp3_vsldeparture_planned_initial"
        ><span
          >Planned Initial :
          <strong>{{
            getSingleShipments.tsp3_vsldeparture_planned_initial | moment
          }}</strong></span
        ></b-col
      >
      <b-col
        md="3"
        class="mt-1 mb-1"
        v-if="getSingleShipments.tsp3_vsldeparture_planned_last"
        ><span
          >Planned Last :
          <strong>{{
            getSingleShipments.tsp3_vsldeparture_planned_last | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1" v-if="getSingleShipments.tsp3_vsldeparture_actual"
        ><span
          >Actual :
          <strong>{{
            getSingleShipments.tsp3_vsldeparture_actual | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1" v-if="getSingleShipments.tsp3_vsldeparture_detected"
        ><span
          >Detected :
          <strong>{{
            getSingleShipments.tsp3_vsldeparture_detected | moment
          }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Transhipment 4 VSL Arrival Details</b></u></b-col
      >
      <b-col
        md="3"
        class="mt-1 mb-1"
        v-if="getSingleShipments.tsp4_vslarrival_planned_initial"
        ><span
          >Planned Initial :
          <strong>{{
            getSingleShipments.tsp4_vslarrival_planned_initial | moment
          }}</strong></span
        ></b-col
      >
      <b-col
        md="3"
        class="mt-1 mb-1"
        v-if="getSingleShipments.tsp4_vslarrival_planned_last"
        ><span
          >Planned Last :
          <strong>{{
            getSingleShipments.tsp4_vslarrival_planned_last | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1" v-if="getSingleShipments.tsp4_vslarrival_actual"
        ><span
          >Actual :
          <strong>{{ getSingleShipments.tsp4_vslarrival_actual | moment }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1" v-if="getSingleShipments.tsp4_vslarrival_detected"
        ><span
          >Detected :
          <strong>{{
            getSingleShipments.tsp4_vslarrival_detected | moment
          }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Transhipment 4 Discharge Details</b></u></b-col
      >
      <b-col
        md="3"
        class="mt-1 mb-1"
        v-if="getSingleShipments.tsp4_discharge_planned_initial"
        ><span
          >Planned Initial :
          <strong>{{
            getSingleShipments.tsp4_discharge_planned_initial | moment
          }}</strong></span
        ></b-col
      >
      <b-col
        md="3"
        class="mt-1 mb-1"
        v-if="getSingleShipments.tsp4_discharge_planned_last"
        ><span
          >Planned Last :
          <strong>{{
            getSingleShipments.tsp4_discharge_planned_last | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1" v-if="getSingleShipments.tsp4_discharge_actual"
        ><span
          >Actual :
          <strong>{{ getSingleShipments.tsp4_discharge_actual | moment }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Transhipment 4 Loaded Details</b></u></b-col
      >
      <b-col
        md="3"
        class="mt-1 mb-1"
        v-if="getSingleShipments.tsp4_loaded_planned_initial"
        ><span
          >Planned Initial :
          <strong>{{
            getSingleShipments.tsp4_loaded_planned_initial | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1" v-if="getSingleShipments.tsp4_loaded_planned_last"
        ><span
          >Planned Last :
          <strong>{{
            getSingleShipments.tsp4_loaded_planned_last | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1" v-if="getSingleShipments.tsp4_loaded_actual"
        ><span
          >Actual :
          <strong>{{ getSingleShipments.tsp4_loaded_actual | moment }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Transhipment 4 VSL Departure Details</b></u></b-col
      >
      <b-col
        md="3"
        class="mt-1 mb-1"
        v-if="getSingleShipments.tsp4_vsldeparture_planned_initial"
        ><span
          >Planned Initial :
          <strong>{{
            getSingleShipments.tsp4_vsldeparture_planned_initial | moment
          }}</strong></span
        ></b-col
      >
      <b-col
        md="3"
        class="mt-1 mb-1"
        v-if="getSingleShipments.tsp4_vsldeparture_planned_last"
        ><span
          >Planned Last :
          <strong>{{
            getSingleShipments.tsp4_vsldeparture_planned_last | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1" v-if="getSingleShipments.tsp4_vsldeparture_actual"
        ><span
          >Actual :
          <strong>{{
            getSingleShipments.tsp4_vsldeparture_actual | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1" v-if="getSingleShipments.tsp4_vsldeparture_detected"
        ><span
          >Detected :
          <strong>{{
            getSingleShipments.tsp4_vsldeparture_detected | moment
          }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>POD VSL Arrival Details</b></u></b-col
      >
      <b-col
        md="3"
        class="mt-1 mb-1"
        v-if="getSingleShipments.pod_vslarrival_planned_initial"
        ><span
          >Planned Initial :
          <strong>{{
            getSingleShipments.pod_vslarrival_planned_initial | moment
          }}</strong></span
        ></b-col
      >
      <b-col
        md="3"
        class="mt-1 mb-1"
        v-if="getSingleShipments.pod_vslarrival_planned_last"
        ><span
          >Planned Last :
          <strong>{{
            getSingleShipments.pod_vslarrival_planned_last | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1" v-if="getSingleShipments.pod_vslarrival_actual"
        ><span
          >Actual :
          <strong>{{ getSingleShipments.pod_vslarrival_actual | moment }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1" v-if="getSingleShipments.pod_vslarrival_detected"
        ><span
          >Detected :
          <strong>{{ getSingleShipments.pod_vslarrival_detected | moment }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>POD Discharge Details</b></u></b-col
      >
      <b-col
        md="3"
        class="mt-1 mb-1"
        v-if="getSingleShipments.pod_discharge_planned_initial"
        ><span
          >Planned Initial :
          <strong>{{
            getSingleShipments.pod_discharge_planned_initial | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1" v-if="getSingleShipments.pod_discharge_planned_last"
        ><span
          >Planned Last :
          <strong>{{
            getSingleShipments.pod_discharge_planned_last | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1" v-if="getSingleShipments.pod_discharge_actual"
        ><span
          >Actual :
          <strong>{{ getSingleShipments.pod_discharge_actual | moment }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>POD Departure Details</b></u></b-col
      >
      <b-col
        md="3"
        class="mt-1 mb-1"
        v-if="getSingleShipments.pod_departure_planned_initial"
        ><span
          >Planned Initial :
          <strong>{{
            getSingleShipments.pod_departure_planned_initial | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1" v-if="getSingleShipments.pod_departure_planned_last"
        ><span
          >Planned Last :
          <strong>{{
            getSingleShipments.pod_departure_planned_last | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1" v-if="getSingleShipments.pod_departure_actual"
        ><span
          >Actual :
          <strong>{{ getSingleShipments.pod_departure_actual | moment }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>LIF Arrival Details</b></u></b-col
      >
      <b-col md="3" v-if="getSingleShipments.lif_arrival_planned_initial"
        ><span
          >Planned Initial :
          <strong>{{
            getSingleShipments.lif_arrival_planned_initial | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" v-if="getSingleShipments.lif_arrival_planned_last"
        ><span
          >Planned Last :
          <strong>{{
            getSingleShipments.lif_arrival_planned_last | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" v-if="getSingleShipments.lif_arrival_actual"
        ><span
          >Actual :
          <strong>{{ getSingleShipments.lif_arrival_actual | moment }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>LIF Departure Details</b></u></b-col
      >
      <b-col md="3" v-if="getSingleShipments.lif_departure_planned_initial"
        ><span
          >Planned Initial :
          <strong>{{
            getSingleShipments.lif_departure_planned_initial | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" v-if="getSingleShipments.lif_departure_planned_last"
        ><span
          >Planned Last :
          <strong>{{
            getSingleShipments.lif_departure_planned_last | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" v-if="getSingleShipments.lif_departure_actual"
        ><span
          >Actual :
          <strong>{{ getSingleShipments.lif_departure_actual | moment }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>DLV Delivery Details</b></u></b-col
      >
      <b-col md="3" v-if="getSingleShipments.dlv_delivery_planned_initial"
        ><span
          >Planned Initial :
          <strong>{{
            getSingleShipments.dlv_delivery_planned_initial | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" v-if="getSingleShipments.dlv_delivery_planned_last"
        ><span
          >Planned Last :
          <strong>{{
            getSingleShipments.dlv_delivery_planned_last | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" v-if="getSingleShipments.dlv_delivery_actual"
        ><span
          >Actual :
          <strong>{{ getSingleShipments.dlv_delivery_actual | moment }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Empty Return Details</b></u></b-col
      >
      <b-col md="3" v-if="getSingleShipments.empty_return_planned_initial"
        ><span
          >Planned Initial :
          <strong>{{
            getSingleShipments.empty_return_planned_initial | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" v-if="getSingleShipments.empty_return_planned_last"
        ><span
          >Planned Last :
          <strong>{{
            getSingleShipments.empty_return_planned_last | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" v-if="getSingleShipments.empty_return_actual"
        ><span
          >Actual :
          <strong>{{ getSingleShipments.empty_return_actual | moment }}</strong></span
        ></b-col
      >
      <b-col md="3" v-if="getSingleShipments.empty_return_customer"
        ><span
          >Customer :
          <strong>{{ getSingleShipments.empty_return_customer }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Custom Details</b></u></b-col
      >
      <b-col md="3" v-if="getSingleShipments.customs_release_state"
        ><span
          >Custom Release State :
          <strong>{{ getSingleShipments.customs_release_state }}</strong></span
        ></b-col
      >
      <b-col md="3" v-if="getSingleShipments.customs_release_date"
        ><span
          >Custom Release Date :
          <strong>{{ getSingleShipments.customs_release_date?(getSingleShipments.customs_release_date | moment):"" }}</strong></span
        ></b-col
      >
      <b-col md="3" v-if="getSingleShipments.carrier_release_state"
        ><span
          >Carrier Release State :
          <strong>{{ getSingleShipments.carrier_release_state }}</strong></span
        ></b-col
      >
      <b-col md="3" v-if="getSingleShipments.carrier_release_date"
        ><span
          >Carrier Release Date :
          <strong>{{ getSingleShipments.carrier_release_date?(getSingleShipments.carrier_release_date | moment):"" }}</strong></span
        ></b-col
      >
      <b-col md="3" v-if="getSingleShipments.availability_date"
        ><span
          >Availability :
          <strong>{{ getSingleShipments.availability_date?(getSingleShipments.availability_date | moment):"" }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2" v-if="getSingleShipments.leg1_vessel">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Vessel 1 Details</b></u></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >ID : <strong>{{ getSingleShipments.leg1_vessel.id }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >IMO : <strong>{{ getSingleShipments.leg1_vessel.imo }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Name : <strong>{{ getSingleShipments.leg1_vessel.name }}</strong></span
        ></b-col
      >
    </b-row>
    <b-row class="mb-2" v-if="getSingleShipments.leg2_vessel">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Vessel 2 Details</b></u></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >ID : <strong>{{ getSingleShipments.leg2_vessel.id }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >IMO : <strong>{{ getSingleShipments.leg2_vessel.imo }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Name : <strong>{{ getSingleShipments.leg2_vessel.name }}</strong></span
        ></b-col
      >
    </b-row>
    <b-row class="mb-2" v-if="getSingleShipments.leg3_vessel">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Vessel 3 Details</b></u></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >ID : <strong>{{ getSingleShipments.leg3_vessel.id }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >IMO : <strong>{{ getSingleShipments.leg3_vessel.imo }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Name : <strong>{{ getSingleShipments.leg3_vessel.name }}</strong></span
        ></b-col
      >
    </b-row>
    <b-row class="mb-2" v-if="getSingleShipments.leg4_vessel">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Vessel 4 Details</b></u></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >ID : <strong>{{ getSingleShipments.leg4_vessel.id }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >IMO : <strong>{{ getSingleShipments.leg4_vessel.imo }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Name : <strong>{{ getSingleShipments.leg4_vessel.name }}</strong></span
        ></b-col
      >
    </b-row>
    <b-row class="mb-2" v-if="getSingleShipments.leg5_vessel">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Vessel 5 Details</b></u></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >ID : <strong>{{ getSingleShipments.leg5_vessel.id }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >IMO : <strong>{{ getSingleShipments.leg5_vessel.imo }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Name : <strong>{{ getSingleShipments.leg5_vessel.name }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2" v-if="getSingleShipments.pod_loc">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>POD Details</b></u></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Name : <strong>{{ getSingleShipments.pod_loc.name }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Locode : <strong>{{ getSingleShipments.pod_loc.locode }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Timezone : <strong>{{ getSingleShipments.pod_loc.timezone }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >City : <strong>{{ getSingleShipments.pod_loc.city }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >State : <strong>{{ getSingleShipments.pod_loc.state }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Country : <strong>{{ getSingleShipments.pod_loc.country }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2" v-if="getSingleShipments.pol_loc">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>POL Details</b></u></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Name : <strong>{{ getSingleShipments.pol_loc.name }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Locode : <strong>{{ getSingleShipments.pol_loc.locode }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Timezone : <strong>{{ getSingleShipments.pol_loc.timezone }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >City : <strong>{{ getSingleShipments.pol_loc.city }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >State : <strong>{{ getSingleShipments.pol_loc.state }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Country : <strong>{{ getSingleShipments.pol_loc.country }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2" v-if="getSingleShipments.dlv_loc">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>DLV Details</b></u></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Name : <strong>{{ getSingleShipments.dlv_loc.name }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Locode : <strong>{{ getSingleShipments.dlv_loc.locode }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Timezone : <strong>{{ getSingleShipments.dlv_loc.timezone }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >City : <strong>{{ getSingleShipments.dlv_loc.city }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >State : <strong>{{ getSingleShipments.dlv_loc.state }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Country : <strong>{{ getSingleShipments.dlv_loc.country }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2" v-if="getSingleShipments.origin_loc">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Origin Details</b></u></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Name : <strong>{{ getSingleShipments.origin_loc.name }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Locode : <strong>{{ getSingleShipments.origin_loc.locode }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Timezone : <strong>{{ getSingleShipments.origin_loc.timezone }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >City : <strong>{{ getSingleShipments.origin_loc.city }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >State : <strong>{{ getSingleShipments.origin_loc.state }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Country : <strong>{{ getSingleShipments.origin_loc.country }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2" v-if="getSingleShipments.tsp1_vslarrival_prediction">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Transhipment 1 VSL Arrival Prediction Details</b></u></b-col
      >
      <b-col md="3"
        ><span
          >Created :
          <strong>{{
            getSingleShipments.tsp1_vslarrival_prediction.created | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3"
        ><span
          >Predicted :
          <strong>{{
            getSingleShipments.tsp1_vslarrival_prediction.predicted | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3"
        ><span
          >Predicted Lower :
          <strong>{{
            getSingleShipments.tsp1_vslarrival_prediction.predicted_lower | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3"
        ><span
          >Predicted Upper :
          <strong>{{
            getSingleShipments.tsp1_vslarrival_prediction.predicted_upper | moment
          }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2" v-if="getSingleShipments.tsp2_vslarrival_prediction">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Transhipment 2 VSL Arrival Prediction Details</b></u></b-col
      >
      <b-col md="3" v-if="getSingleShipments.tsp2_vslarrival_prediction"
        ><span
          >Created :
          <strong>{{
            getSingleShipments.tsp2_vslarrival_prediction.created | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" v-if="getSingleShipments.tsp2_vslarrival_prediction"
        ><span
          >Predicted :
          <strong>{{
            getSingleShipments.tsp2_vslarrival_prediction.predicted | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" v-if="getSingleShipments.tsp2_vslarrival_prediction"
        ><span
          >Predicted Lower :
          <strong>{{
            getSingleShipments.tsp2_vslarrival_prediction.predicted_lower | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" v-if="getSingleShipments.tsp2_vslarrival_prediction"
        ><span
          >Predicted Upper :
          <strong>{{
            getSingleShipments.tsp2_vslarrival_prediction.predicted_upper | moment
          }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2" v-if="getSingleShipments.tsp3_vslarrival_prediction">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Transhipment 3 VSL Arrival Prediction Details</b></u></b-col
      >
      <b-col md="3"
        ><span
          >Created :
          <strong>{{
            getSingleShipments.tsp3_vslarrival_prediction.created | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3"
        ><span
          >Predicted :
          <strong>{{
            getSingleShipments.tsp3_vslarrival_prediction.predicted | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3"
        ><span
          >Predicted Lower :
          <strong>{{
            getSingleShipments.tsp3_vslarrival_prediction.predicted_lower | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3"
        ><span
          >Predicted Upper :
          <strong>{{
            getSingleShipments.tsp3_vslarrival_prediction.predicted_upper | moment
          }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2" v-if="getSingleShipments.tsp4_vslarrival_prediction">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Transhipment 4 VSL Arrival Prediction Details</b></u></b-col
      >
      <b-col md="3"
        ><span
          >Created :
          <strong>{{
            getSingleShipments.tsp4_vslarrival_prediction.created | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3"
        ><span
          >Predicted :
          <strong>{{
            getSingleShipments.tsp4_vslarrival_prediction.predicted | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3"
        ><span
          >Predicted Lower :
          <strong>{{
            getSingleShipments.tsp4_vslarrival_prediction.predicted_lower | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3"
        ><span
          >Predicted Upper :
          <strong>{{
            getSingleShipments.tsp4_vslarrival_prediction.predicted_upper | moment
          }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2" v-if="getSingleShipments.pod_vslarrival_prediction">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>POD VSL Arrival Prediction Details</b></u></b-col
      >
      <b-col md="3"
        ><span
          >Created :
          <strong>{{
            getSingleShipments.pod_vslarrival_prediction.created | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3"
        ><span
          >Predicted :
          <strong>{{
            getSingleShipments.pod_vslarrival_prediction.predicted | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3"
        ><span
          >Predicted Lower :
          <strong>{{
            getSingleShipments.pod_vslarrival_prediction.predicted_lower | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3"
        ><span
          >Predicted Upper :
          <strong>{{
            getSingleShipments.pod_vslarrival_prediction.predicted_upper | moment
          }}</strong></span
        ></b-col
      >
    </b-row>
    <b-row class="mb-2" v-if="getSingleShipments.pod_timeofarrival_warning">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>POD Discharge Prediction Details</b></u></b-col
      >
      <b-col md="3"
        ><span
          >Risk Verbose :<strong>{{
            getSingleShipments.pod_timeofarrival_warning.risk_verbose
          }}</strong></span
        ></b-col
      >
      <b-col
        md="3"
        class="mt-1 mb-1"
        v-if="getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival"
        ><span
          >ID :<strong>{{
            getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival.id
          }}</strong></span
        ></b-col
      >
      <b-col
        md="3"
        v-if="getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival"
        ><span
          >Created :<strong>{{
            getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival.created
              | moment
          }}</strong></span
        ></b-col
      >
      <b-col
        md="3"
        v-if="getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival"
        ><span
          >Milestone :<strong>{{
            getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival
              .milestone
          }}</strong></span
        ></b-col
      >
      <b-col
        md="3"
        v-if="getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival"
        ><span
          >Predicted Date :<strong>{{
            getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival
              .predicted_date | moment
          }}</strong></span
        ></b-col
      >
      <b-col
        md="3"
        class="mt-1 mb-1"
        v-if="getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival"
        ><span
          >Days Diff :<strong>{{
            getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival
              .days_diff
          }}</strong></span
        ></b-col
      >
      <b-col
        md="3"
        v-if="getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival"
        ><span
          >Predicted Date Lower :<strong>{{
            getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival
              .predicted_date_lower | moment
          }}</strong></span
        ></b-col
      >
      <b-col
        md="3"
        v-if="getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival"
        ><span
          >Predicted Date Uppper :<strong>{{
            getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival
              .predicted_date_upper | moment
          }}</strong></span
        ></b-col
      >
      <b-col
        md="3"
        v-if="getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival"
        ><span
          >Expected Date Created :<strong>{{
            getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival
              .expected_date_when_created | moment
          }}</strong></span
        ></b-col
      >
      <b-col
        md="3"
        v-if="getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival"
        ><span
          >Connection Date Created :<strong>{{
            getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival
              .connection_date_when_created | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" v-if="getSingleShipments.pod_timeofarrival_warning"
        ><span
          >Created :<strong>{{
            getSingleShipments.pod_timeofarrival_warning.created | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3" v-if="getSingleShipments.pod_timeofarrival_warning"
        ><span
          >Modified :<strong>{{
            getSingleShipments.pod_timeofarrival_warning.modified | moment
          }}</strong></span
        ></b-col
      >
    </b-row>
    <b-row class="mb-2" v-if="getSingleShipments.pod_discharge_prediction">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>POD Discharge Prediction Details</b></u></b-col
      >
      <b-col md="3"
        ><span
          >Created :
          <strong>{{
            getSingleShipments.pod_discharge_prediction.created | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3"
        ><span
          >Predicted :
          <strong>{{
            getSingleShipments.pod_discharge_prediction.predicted | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3"
        ><span
          >Predicted Lower :
          <strong>{{
            getSingleShipments.pod_discharge_prediction.predicted_lower | moment
          }}</strong></span
        ></b-col
      >
      <b-col md="3"
        ><span
          >Predicted Upper :
          <strong>{{
            getSingleShipments.pod_discharge_prediction.predicted_upper | moment
          }}</strong></span
        ></b-col
      >
    </b-row>

    <b-row class="mb-2" v-if="getSingleShipments.leg1_service">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Leg Service 1 Details</b></u></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >ID : <strong>{{ getSingleShipments.leg1_service.id }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Code : <strong>{{ getSingleShipments.leg1_service.code }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Name : <strong>{{ getSingleShipments.leg1_service.name }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Direction :
          <strong>{{ getSingleShipments.leg1_service.direction }}</strong></span
        ></b-col
      >
    </b-row>
    <b-row class="mb-2" v-if="getSingleShipments.leg2_service">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Leg Service 2 Details</b></u></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >ID : <strong>{{ getSingleShipments.leg2_service.id }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Code : <strong>{{ getSingleShipments.leg2_service.code }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Name : <strong>{{ getSingleShipments.leg2_service.name }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Direction :
          <strong>{{ getSingleShipments.leg2_service.direction }}</strong></span
        ></b-col
      >
    </b-row>
    <b-row class="mb-2" v-if="getSingleShipments.leg3_service">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Leg Service 3 Details</b></u></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >ID : <strong>{{ getSingleShipments.leg3_service.id }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Code : <strong>{{ getSingleShipments.leg3_service.code }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Name : <strong>{{ getSingleShipments.leg3_service.name }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Direction :
          <strong>{{ getSingleShipments.leg3_service.direction }}</strong></span
        ></b-col
      >
    </b-row>
    <b-row class="mb-2" v-if="getSingleShipments.leg4_service">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Leg Service 4 Details</b></u></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >ID : <strong>{{ getSingleShipments.leg4_service.id }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Code : <strong>{{ getSingleShipments.leg4_service.code }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Name : <strong>{{ getSingleShipments.leg4_service.name }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Direction :
          <strong>{{ getSingleShipments.leg4_service.direction }}</strong></span
        ></b-col
      >
    </b-row>
    <b-row class="mb-2" v-if="getSingleShipments.leg5_service">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Leg Service 5 Details</b></u></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >ID : <strong>{{ getSingleShipments.leg5_service.id }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Code : <strong>{{ getSingleShipments.leg5_service.code }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Name : <strong>{{ getSingleShipments.leg5_service.name }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Direction :
          <strong>{{ getSingleShipments.leg5_service.direction }}</strong></span
        ></b-col
      >
    </b-row>
    <b-row class="mb-2" v-if="getSingleShipments.empty_pickup_loc">
      <b-col md="12" class="mt-1 mb-1" style="color: blue"
        ><u><b>Empty Pickup Loc Details</b></u></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Name : <strong>{{ getSingleShipments.empty_pickup_loc.name }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Locode :
          <strong>{{ getSingleShipments.empty_pickup_loc.locode }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Timezone :
          <strong>{{ getSingleShipments.empty_pickup_loc.timezone }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >City : <strong>{{ getSingleShipments.empty_pickup_loc.city }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >State : <strong>{{ getSingleShipments.empty_pickup_loc.state }}</strong></span
        ></b-col
      >
      <b-col md="3" class="mt-1 mb-1"
        ><span
          >Country :
          <strong>{{ getSingleShipments.empty_pickup_loc.country }}</strong></span
        ></b-col
      >
    </b-row>
    <!-- {{parsedIncidents}} -->

    <div class="alerts" v-if="getSingleShipments.incidents">
      <div
        v-for="(incident, index) in getSingleShipments.incidents"
        :key="index"
        class="alert"
      >
        {{ incident }}
      </div>
    </div>
    <div class="details">
      <!-- Other details can be added here -->

      <b-modal
        id="ShipmentLog_modal"
        ref="ShipmentLog_modal"
        :title="
          'Shipment Log Details Container No : ' + getSingleShipments.container_number
        "
        size="lg"
        no-close-on-esc
        no-close-on-backdrop
        hide-footer
      >
        <b-row>
          <b-col md="12">
            <b-table
              show-empty
              stacked="md"
              :items="getShipmentLogList"
              responsive
              :fields="Columns"
              primary-key="id_email_section"
              :per-page="perPage"
              :filter="filter"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              class="position-relative"
            >
              <template slot="SN" slot-scope="row0">
                <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <div class="row">
          <div class="col-md-12 text-center">
            <center>
              <b-button
                @click="hideShipmentLog"
                style="font-size: 11px"
                size="sm"
                class="mt-2"
                variant="danger"
                >Close</b-button
              >
            </center>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import CommonService from "../../services/CommonService.js";
export default {
  props: {
    getSingleShipments: {
      type: Object,
      default: {},
    },
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.Columns.filter((f) => f.sortable).map((f) => {
        return { text: f.label, value: f.key };
      });
    },
  },
  data() {
    return {
      getShipmentLogList:[],
      Columns: [
        {
          key: "SN",
          mainkey: "SN",
          label: "",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "shipmentId",
          mainkey: "shipmentId",
          label: "Shipment NO",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "SubscriptionId",
          mainkey: "SubscriptionId",
          label: "Subscription NO",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "Vessel_Name",
          mainkey: "Vessel_Name",
          label: "Vessel Name",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "Vessel_Vyoge",
          mainkey: "Vessel_Vyoge",
          label: "Voyage No",
          sortable: true,
          sortDirection: "ASC",
          table: "E.",
        },
        {
          key: "SOB",
          mainkey: "SOB",
          label: "SOB Date",
          sortable: true,
          sortDirection: "ASC",
          table: "F.",
        },
        {
          key: "created_at",
          mainkey: "created_at",
          label: "Created Date",
          sortable: true,
          sortDirection: "ASC",
          table: "F.",
        },
      ],
      containerId: "TGBU8923381",
      subscriptionId: "233508182",
      hasStoppedMovements: true,
      hasBanOnShips: true,
      carrier: "Maersk",
      description: "40 ft High Cube Container",
      incidentString: this.getSingleShipments.pod_timeofarrival_warning
        ? this.getSingleShipments.pod_timeofarrival_warning.risk_description
        : "",
      parsedIncidents: [],
      currentPage: 1,
      perPage: 50,
      totalRows: 0,
      sortBy: null,
      sortDesc: false,
      pageOptions: [5, 10, 15],
      sortDirection: "desc",
      filter: null,
      // Add other details as required
    };
  },
  methods: {
    getShipmentLog(getSingleShipments) {
      let shipmentId = getSingleShipments.id;
      console.log("shipmentId=>", shipmentId);

      let payload = {
        itemCode: "getShipmentLog",
        shipmentId: shipmentId,
      };
      CommonService.getAllExpenseList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data.FLAG == 1) {
            this.getShipmentLogList = data.getShipmentLogList;
            this.$refs["ShipmentLog_modal"].show();
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getShipmentLog Error: ", error);
        });
    },
    hideShipmentLog() {
      this.$refs["ShipmentLog_modal"].hide();
    },
    parseIncidents() {
      const regex = /'([^']+)'/g;
      const matches = this.incidentString.match(regex);

      if (matches) {
        this.parsedIncidents = matches.map((message) => ({ message }));
      }
    },
  },
  mounted() {
    this.parseIncidents();
  },
};
</script>

<style scoped>
.container-details {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
}

.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.alerts {
  margin-bottom: 20px;
}

.alert {
  color: #d9534f;
  padding: 10px;
  background-color: #f2dede;
  border: 1px solid #ebccd1;
  border-radius: 4px;
  margin-bottom: 10px;
}

.details {
  border-top: 1px solid #eee;
  padding-top: 20px;
}

.label {
  font-weight: bold;
}
.invalid-date {
  background-color: white;
  /* Add any additional styling as needed */
}
.Invalid {
  color: white;
  /* Add any additional styling as needed */
}
</style>



// WEBPACK FOOTER //
// ContainerDetails.vue?36a6ee73